module.exports = __webpack_public_path__ + "static/media/logo-half-top.711d2608.svg";